import { useTranslation } from '@shared/config/i18n'
import { Fragment } from 'react'

import { Box, Typography, VStack } from '@podo-app/design-system-temp'

const IPAD_PACKAGE_PRODUCT_MESSAGE_KEYS = [
  'subscribeList.paymentTypeHero.ipadProductIpad',
  'subscribeList.paymentTypeHero.ipadProductPencil',
] as const

const DeliveryInformationCard = () => {
  const t = useTranslation()

  return (
    <VStack className="p-5 bg-gray-100 border border-gray-200 rounded-lg gap-4">
      {IPAD_PACKAGE_PRODUCT_MESSAGE_KEYS.map((messageKey, index) => (
        <Fragment key={messageKey}>
          <VStack className="gap-1">
            <Typography size="h6">{t(messageKey)}</Typography>
          </VStack>
          {index < IPAD_PACKAGE_PRODUCT_MESSAGE_KEYS.length - 1 && <Box className="h-px bg-gray-200" />}
        </Fragment>
      ))}
    </VStack>
  )
}

export default DeliveryInformationCard
